import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32.6665 0H0.666504V32H32.6665V0Z",
      class: "bg",
      fill: "#DAF6FF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M26.1065 8.00039L23.7865 6.52039C23.4589 6.32275 23.0665 6.26231 22.6946 6.35218C22.3226 6.44204 22.0011 6.67496 21.7999 7.00039L14.7465 18.5204L10.1599 15.6937C9.99757 15.592 9.81661 15.5237 9.62759 15.4928C9.43857 15.4618 9.24528 15.4689 9.05903 15.5136C8.87279 15.5583 8.69733 15.6397 8.54293 15.7531C8.38853 15.8664 8.2583 16.0094 8.15986 16.1737L6.74652 18.4804C6.54889 18.808 6.48845 19.2004 6.57831 19.5724C6.66818 19.9443 6.9011 20.2658 7.22652 20.4671L15.3332 25.4804C15.6629 25.6787 16.0573 25.7395 16.4314 25.6497C16.8055 25.5599 17.1294 25.3267 17.3332 25.0004L26.5599 9.93372C26.7436 9.61408 26.799 9.23653 26.7149 8.87756C26.6307 8.51858 26.4132 8.20502 26.1065 8.00039Z",
      class: "primary",
      fill: "#00BBF9"
    }, null, -1)
  ])))
}
export default { render: render }